import { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { getCurrentCycle, listEvaluations } from '../lib/db.js';
import { StatusBar } from '../components/StatusBar.jsx';
import { BottomNav } from '../components/BottomNav.jsx';
import { thaiDate } from '../lib/format.js';

export function EvaluationCycle() {
  const nav = useNavigate();
  const [cycle, setCycle] = useState(null);
  const [rows, setRows] = useState(null);
  const [err, setErr] = useState('');

  useEffect(() => {
    (async () => {
      try {
        const c = await getCurrentCycle();
        setCycle(c);
        setRows(await listEvaluations(c?.id));
      } catch (e) { setErr(e.message); setRows([]); }
    })();
  }, []);

  const done = (rows || []).filter((r) => r.status === 'submitted' || r.status === 'acknowledged').length;
  const pct = rows && rows.length ? Math.round((done / rows.length) * 100) : 0;

  return (
    <div className="phone">
      <StatusBar />
      <section className="screen">
        <button className="back" onClick={() => nav(-1)}>‹ กลับ</button>
        <div className="title-row">
          <div><div className="eyebrow">รอบประเมิน{cycle?.announced_at ? ' · ประกาศแล้ว' : ''}</div>
            <h1 className="page">ประเมินผล</h1></div>
          <span className="glyph">◷</span>
        </div>

        {err && <p className="err">{err}</p>}
        {!rows && <div className="center"><div className="spinner" /></div>}

        {rows && (
          <>
            <div className="hero"><div className="num">{pct}<small style={{ fontSize: 40 }}>%</small></div>
              <div className="sub">ประเมินเสร็จ {done}/{rows.length} คน</div></div>
            {cycle && (
              <div className="leave-note" style={{ background: 'var(--surface-2)' }}>
                <b>{cycle.name}</b> · {thaiDate(cycle.period_start)}–{thaiDate(cycle.period_end)}
                {cycle.announced_at ? ` · ประกาศเกณฑ์ ${thaiDate(cycle.announced_at)}` : ''}
              </div>
            )}
            <hr className="hr" />
            <div className="sec-label">พนักงานในรอบนี้</div>
            <div className="list-grid">
              {rows.map((r) => (
                <Link className="row" key={r.employee_id} to={`/evaluations/${r.employee_id}`}>
                  <div className="ic">{r.overall_score != null ? r.overall_score : '–'}</div>
                  <div className="main">
                    <div className="l1">{name(r)}</div>
                    <div className="l2">{r.position || '—'}</div>
                  </div>
                  <span className={`tag ${tag(r.status)}`}>{statusTh(r.status)}</span>
                </Link>
              ))}
            </div>
          </>
        )}
      </section>
      <BottomNav />
    </div>
  );
}

const name = (r) => r.emp_name || (r.employees ? (r.employees.nickname || r.employees.first_name) : '');
const statusTh = (s) => ({ not_started: 'ยังไม่ประเมิน', draft: 'ร่าง', submitted: 'รอรับทราบ', acknowledged: 'รับทราบแล้ว' }[s] || s);
const tag = (s) => ({ acknowledged: 'ok', submitted: 'pend', draft: 'pend', not_started: 'warn' }[s] || 'pend');
